// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import appointmentsReducer from './slices/appointmentsSlice';
import servicesReducer from './slices/servicesSlice';
import stylistsReducer from './slices/stylistsSlice';
import reviewsReducer from './slices/reviewsSlice';
import loyaltyReducer from './slices/loyaltySlice';
import notificationsReducer from './slices/notificationsSlice';
import chatReducer from './slices/chatSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    appointments: appointmentsReducer,
    services: servicesReducer,
    stylists: stylistsReducer,
    reviews: reviewsReducer,
    loyalty: loyaltyReducer,
    notifications: notificationsReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore specific paths where non-serializable data may exist
        ignoredActions: ['appointments/createAppointment/fulfilled', 'services/createService/fulfilled'],
        ignoredPaths: ['payload.date', 'payload.time'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use named export for modules that require direct access to store
export { store };
export default store;